import { isNumeric } from '../isNumeric';

const percentage = (content: string): string => {
  return isNumeric(content) ? String(content).replace('.', ',') : content;
};
export default percentage;
